import { FC, SVGProps } from 'react';
import { Settings } from 'react-slick';
import { ReactComponent as ShoppingBasket } from '@assets/icons/basket-shopping.svg';
import { ReactComponent as ShoppingBag } from '@assets/icons/shopping-bag.svg';
import { ReactComponent as ShoppingCart } from '@assets/icons/shopping-cart.svg';

import { ShoppingCartName, ShoppingCartResponse } from 'types';

export enum DaysMask {
  Sunday = 1,
  Monday = 2,
  Tuesday = 4,
  Wednesday = 8,
  Thursday = 16,
  Friday = 32,
  Saturday = 64
}

export const SIGN_MODE = {
  drawing: 'drawing',
  typing: 'typing'
};

export const googleMapURL = 'https://www.google.com/maps';

export const defaultSettings: Settings = {
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false
};

export const defaultProvider = {
  id: -1,
  img: '',
  svc_price: 0,
  name: 'Any Provider',
  description: 'We will select a qualified provider for you'
};

export const zeroDate = '1899-12-30T00:00:00.000Z';

export const defaultBasketData: ShoppingCartResponse = {
  details: {
    invoice_id: null,
    total_cost: 0,
    tax_cost: 0,
    total_items_cost: 0,
    shipping_id: null,
    is_pickup: null,
    shipping_cost: null,
    shipping_addr: {
      pickup_store_id: null,
      addr_id: null
    }
  },
  items: [],
  payments: []
};

export const PRODUCTS_PER_PAGE = 21;

export const ShoppingCartIcon: {
  [key in ShoppingCartName]: FC<SVGProps<SVGSVGElement>>;
} = {
  [ShoppingCartName.Cart]: ShoppingCart,
  [ShoppingCartName.Bag]: ShoppingBag,
  [ShoppingCartName.Basket]: ShoppingBasket
};

export const skeletonColor = {
  start: 'colors.gray.100',
  end: 'colors.gray.200'
};

export const NULLABLE_PRICE = '0.00';

export const GUEST_SESSION_KEY = 'guest_session_data';

export const ProductDetailStorageKey = 'fromProductDetail';
